<!-- -->
@let listCount = customListCount ? customListCount() : null;
<!-- -->
@let listLimit = customListLimit ? customListLimit() : null;
<!-- -->
@let entryCount = customEntryCount ? customEntryCount() : null;
<!-- -->
@let entryLimit = customEntryLimit ? customEntryLimit() : null;
<!-- -->

<bn-web-ui-card
  class="mb-4 color-dark-7"
  heading="Custom access lists"
  [isMaxWidth]="true"
  [learnMore]="{ href: 'https://docs.bunny.net/docs/shield-access-lists' }">
  Build your own tailored access control rules by filtering requests based on IP addresses, CIDR blocks, Autonomous System Numbers (ASNs), or countries. With
  flexible actions to block, challenge, or allow traffic, Custom Access Lists let you precisely control who can access your content.
  <div class="mt-4 d-flex align-items-center">
    <span class="text-200-semi-bold text-dark-8 me-4">Usage</span>
    @if (!isLoading() && listCount !== null) {
      <bn-web-ui-badge
        color=""
        contentClass="me-2"
        >{{ listCount }}/{{ listLimit }} lists</bn-web-ui-badge
      >
      <bn-web-ui-badge color="">{{ entryCount }}/{{ entryLimit }} entries</bn-web-ui-badge>
    } @else {
      <ngx-skeleton-loader
        class="d-flex align-items-center me-2"
        [theme]="{ 'width.px': 60, 'height.px': 20, 'margin-bottom.px': 0 }" />
      <ngx-skeleton-loader
        class="d-flex align-items-center"
        [theme]="{ 'width.px': 60, 'height.px': 20, 'margin-bottom.px': 0 }" />
    }
  </div>
</bn-web-ui-card>

<app-shield-action-precedence-component />

@for (item of storeCustomList(); track $index) {
  <app-shield-access-lists-threat-item
    listKey="customLists"
    [item]="item" />
}

@if (storeCustomList() === null || (storeCustomList()?.length === 0 && isLoading())) {
  <app-shield-access-lists-threat-item
    listKey="customLists"
    [isSkeleton]="true" />
}

@if (storeCustomList()?.length === 0 && !isLoading()) {
  <bn-web-ui-not-available
    [options]="{
      title: 'No custom access lists records',
      size: 'lg',
      description: 'You dont have any custom access lists.',
      imageOptions: {
        fileName: 'bunny-operator-searching.svg',
      },
    }" />
}
